import { render, staticRenderFns } from "./RecordListFilter.vue?vue&type=template&id=8c0b10b0&scoped=true&lang=pug&"
import script from "./RecordListFilter.vue?vue&type=script&lang=ts&"
export * from "./RecordListFilter.vue?vue&type=script&lang=ts&"
import style0 from "./RecordListFilter.vue?vue&type=style&index=0&id=8c0b10b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0b10b0",
  null
  
)

export default component.exports